module.exports = __webpack_public_path__ + "img/img-homepage-p-lc.54f462c6.jpg";